import type { CSSProperties } from "react";

/** Right-aligns a numeric column's cells; see `EndAlignedHeader` for the header label. */
export const endAlignedCellStyle: CSSProperties = { textAlign: "right" };
